import {NgModule} from '@angular/core';

import {PrismLogoComponent} from './index';
import {IonicModule} from 'ionic-angular';

/**
 * Module for the logo component
 */
@NgModule({
  declarations: [PrismLogoComponent],
  exports: [PrismLogoComponent],
  imports: [
    IonicModule,
  ],
  providers: [],
})
export class PrismLogoModule {
}



// WEBPACK FOOTER //
// ./src/app/shared/components/prism-logo/prism-logo.module.ts